import { UserRole } from "@faire/web-api/indigofair/data/UserRole";

import { UserStore } from "@faire/retailer/stores/domain/UserStore";

export const isAdmin = () =>
  !!UserStore.get().user?.roles?.find((role) => role === UserRole.ADMIN);
